import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const CustompiechartCustomer = ({ data ,color = '#ffc107'  }) => {
  const chartRef = useRef(null);

useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);
    const formattedData = data.map(item => ({
      value: item.value,
      name: item.label,
      itemStyle: {
        color: item.color
      }
    }));

      const totalValue = data.reduce((sum, item) => sum + item.value, 0);
    if (totalValue === 0) {
      chartInstance.setOption({
        title: {
          text: 'No Data Available',
          left: 'center',
          top: 'center',
          textStyle: {
            color: '#999',
            fontSize: 20
          }
        }
      });
      return;
    }


  const option = {
  tooltip: { show: false },
//   legend: {
//     orient: 'vertical',
//     right: 10,
//      left: '70%',        // ⬅️ Positions the entire legend block 70% from the left edge
//     top: 'center',
//   itemGap: 6, // ⬅️ Increase for more vertical space between items
//   itemWidth: 20, // Matches the visual block size in the image
//   itemHeight: 20,
//     textStyle: {
//       fontSize: 19,
//       rich: {
//         name: { fontSize: 19, color: '#000',
//                   padding: [10, 10, 10, 4] // Top, Right, Bottom, Left (adds space after label)

//          },
//         value: { fontWeight: '500', fontSize: 19, color: '#000' ,         padding: [10, 10, 10, 20] // Adds left space before the value
// },
//       }
//     },
//     formatter: function (name) {
//       const item = data.find(d => d.label === name);
//     return `{name|${name}}  {value|${item ? `  ${item.value}` : 0}}`;
//     },
//     data: data.map(item => item.label)
//   },

  legend: {
    orient: 'vertical',
    right: 10,
     left: '70%',        // ⬅️ Positions the entire legend block 70% from the left edge
    top: 'center',
  itemGap: 6, // ⬅️ Increase for more vertical space between items
  itemWidth: 20, // Matches the visual block size in the image
  itemHeight: 20,
    textStyle: {
      fontSize: 12,
      rich: {
        name: { fontSize: 12, color: '#000',
                  padding: [10, 10, 10, 4] // Top, Right, Bottom, Left (adds space after label)

         },
        value: { fontWeight: '500', fontSize: 12, color: '#000' ,         padding: [10, 10, 10, 10] // Adds left space before the value
},
      }
    },
    formatter: function (name) {
      const item = data.find(d => d.label === name);
    return `{name|${name}}  {value|${item ? `  ${item.value}` : 0}}`;
    },
    data: data.map(item => item.label)
  },

  series: [
    // 🎯 Adjusted main donut to touch inner white ring
    {
      type: 'pie',
      radius: ['20%', '75%'], 
      center: ['30%', '50%'],
      startAngle: 90,
      label: { show: false },
      labelLine: { show: false },
      data: formattedData
    },
    // ⚪ Inner white filled circle
    {
      type: 'pie',
      radius: ['0%', '10%'],
      center: ['30%', '50%'],
      silent: true,
      label: { show: false },
      data: [{ value: 1, itemStyle: { color: '#fff' } }]
    },
    // ⚪ White ring (outer circle)
    {
      type: 'pie',
      radius: ['10.5%', '16%'], // ⬅️ slightly overlaps main donut
      center: ['30%', '50%'],
      silent: true,
      label: { show: false },
       data: formattedData
    }
  ]
};


    chartInstance.setOption(option);

    return () => {
      chartInstance.dispose();
    };
  }, [color , data]);

  return (
    <div
      ref={chartRef}
      style={{ width: '670px', height: '480px' }}
    />
  );
};

export default CustompiechartCustomer;
